import React, { useRef } from 'react';

interface ReportLayoutProps {
  sidebar: React.ReactNode;
  children: React.ReactNode;
  maxWidth?: number | string;
  sidebarWidth?: number | string;
  onPrint?: () => void;
  printId?: string; // id vùng cần in, nếu muốn in vùng khác ngoài .report-content
}

const ReportLayout: React.FC<ReportLayoutProps> = ({
  sidebar,
  children,
  maxWidth = 1900,
  sidebarWidth = 320,
  onPrint,
  printId,
}) => {
  // Hàm in chỉ vùng báo cáo (mặc định là .report-content, hoặc theo printId)
  const handlePrint = () => {
    if (printId) {
      const printSection = document.getElementById(printId);
      if (printSection) {
        const printWindow = window.open('', '', 'height=800,width=1200');
        if (printWindow) {
          printWindow.document.write('<html><head><title>In báo cáo</title>');
          // Lấy toàn bộ CSS hiện tại
          document.querySelectorAll('link[rel="stylesheet"], style').forEach((node) => {
            printWindow.document.write(node.outerHTML);
          });
          printWindow.document.write('</head><body>');
          printWindow.document.write(printSection.outerHTML);
          printWindow.document.write('</body></html>');
          printWindow.document.close();
          printWindow.focus();
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 300);
        }
      }
    } else {
      window.print();
    }
  };

  return (
    <div className="report-root" style={{ fontFamily: 'Roboto, sans-serif', margin: 20, color: '#333', background: '#f4f4f4', minHeight: '100vh' }}>
      <div
        style={{
          maxWidth,
          margin: 'auto',
          background: '#fff',
          padding: 0,
          borderRadius: 8,
          boxShadow: '0 0 15px rgba(0,0,0,0.1)',
          display: 'flex',
          flexDirection: 'row',
          gap: 0,
          minHeight: 600,
          height: 'calc(95vh - 40px)',
          overflow: 'hidden',
        }}
      >
        {/* Nội dung báo cáo */}
        <div className="report-content" style={{ flex: 1, padding: 30, minWidth: 0, overflowY: 'auto', height: '95vh', boxSizing: 'border-box' }}>
          {children}
        </div>
        {/* Sidebar */}
        <div
          className="report-sidebar"
          style={{
            width: sidebarWidth,
            minWidth: 220,
            maxWidth: 320,
            borderLeft: '1px solid #eee',
            background: '#fafbfc',
            padding: 24,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: 24,
            position: 'sticky',
            top: 0,
            height: '95vh',
            zIndex: 2,
            boxSizing: 'border-box',
          }}
        >
          {sidebar}
        </div>
      </div>
    </div>
  );
};

export default ReportLayout; 